import { io, type Socket } from 'socket.io-client';
import { env } from '@/shared/config/env';

let socket: Socket | null = null;

export const connectSocket = (accessToken: string): Socket => {
  if (socket?.connected) return socket;
  if (socket) socket.disconnect();

  socket = io(`${env.VITE_SOCKET_URL}/chat`, {
    auth: { token: accessToken },
    transports: ['websocket'],
    autoConnect: true,
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 1000,
    reconnectionDelayMax: 10_000,
  });
  return socket;
};

export const getSocket = (): Socket | null => socket;

export const disconnectSocket = (): void => {
  socket?.disconnect();
  socket = null;
};
